import BpSmallLogoSvg from 'assets/images/bp-logo.png'
import BpSmallAltLogoSvg from 'assets/images/bp-logo.png'
import BpFullLogoSvg from 'assets/images/brownie-points-logo-standard.svg'
import BpFullAltLogoSvg from 'assets/images/brownie-points-logo-standard-white.svg'
import BpLoginLogo from 'assets/images/bp-logo.png'

import GsSmallLogoSvg from 'assets/images/gs_logo.webp'
import GsFullLogoSvg from 'assets/images/gs_logo.webp'
import GsLoginLogo from 'assets/images/gs_logo.webp'
import GsFullLogoWhiteSvg from 'assets/images/gs_logo.webp'

const isGrowsmart = true
const logoPath = isGrowsmart ? GsFullLogoSvg : BpFullLogoSvg
const smallLogoPath = isGrowsmart ? GsSmallLogoSvg : BpSmallLogoSvg
const smallAltLogoPath = isGrowsmart ? GsSmallLogoSvg : BpSmallAltLogoSvg
const fullAltLogoPath = isGrowsmart ? GsFullLogoSvg : BpFullAltLogoSvg
const loginLogo = isGrowsmart ? GsLoginLogo : BpLoginLogo
const dashSidebarLogo = isGrowsmart ? GsFullLogoWhiteSvg : BpFullLogoSvg

export default {
  loginLogo,
  logoPath,
  smallLogoPath,
  smallAltLogoPath,
  fullAltLogoPath,
  dashSidebarLogo
}
